import Button from "../../components/Button";
import Input from "../../components/Input/InputSignUp";
import MaskInput from "../../components/Input/MaskInput";
import {alert} from "../../components/Alert";
import { MdEmail, MdLock, MdPhone } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { useState, useRef } from "react";
import { Container } from "./styles";
import { api } from "../../services/api";
import ReCAPTCHA from "react-google-recaptcha";
import Modal from "./Modal";

const SignUp = () => {

  let { id } = useParams();

  const [name, setName] = useState("");
  const [nameFailure, setNameFailure] = useState(false);
  const [email, setEmail] = useState("");
  const [emailFailure, setEmailFailure] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordFailure, setPasswordFailure] = useState(false);
  const [password_confirmation, setPassword_confirmation] = useState("");
  const [passwordConfirmationFailure, setPasswordConfirmationFailure] = useState(false);
  const [cpf, setCpf] = useState("");
  const [cpfFailure, setCpfFailure] = useState(false);
  const [cep, setCep] = useState("");
  const [cepFailure, setCepFailure] = useState(false);
  const [rg, setRG] = useState("");
  const [rgFailure, setRgFailure] = useState(false);
  const [street, setStreet] = useState('');
  const [streetFailure, setStreetFailure] = useState(false);
  const [street_number, setStreet_number] = useState('');
  const [streetNumberFailure, setStreetNumberFailure] = useState(false);
  const [city, setCity] = useState('');
  const [cityFailure, setCityFailure] = useState(false);
  const [state, setState] = useState('');
  const [stateFailure, setStateFailure] = useState(false);
  const [ddd, setDdd] = useState('');
  const [dddFailure, setDddFailure] = useState(false);
  const [number, setNumber] = useState("");
  const [numberFailure, setNumberFailure] = useState(false);
  const [neighborhood, setNeighborhood] = useState("");
  const [neighborhoodFailure, setNeighborhoodFailure] = useState(false);

  const [captcha, setCaptcha] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const history = useHistory();

  const handleSubmit = async () => {

    try {
      const response = await api.post("/clients/create", {
        client: {
          name,
          email,
          password,
          password_confirmation,
          cpf,
          rg,
          retailer_id: id,
          ddd,
          phone: number,
          street,
          street_number,
          city,
          state,
          cep,
          neighborhood
        },
      });
      if (response.data) {
        alert("Usuário criado.", 'success');
      }
    } catch (error) {
      alert('Erro, tente novamente.',"error");
    }
  };

  function onBlurCep(event) {
    const { value } = event.target;
    const cep = value?.replace(/[^0-9]/g, "");

    if (cep?.length !== 8) {
      return;
    }
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json()) // Retorna o json da api viacep
      .then((data) => {
        setStreet(data.logradouro)
        setCity(data.localidade)
        setState(data.uf)
        setDdd(data.ddd)
        setNeighborhood(data.bairro)
      });
  }

  const checkParams = () => {
    if (name === '') {
      setNameFailure(true);
      return false;
    }

    if (email === '') {
      setEmailFailure(true);
      return false;
    }

    if (password === '') {
      setPasswordFailure(true);
      return false;
    }

    if (password_confirmation === '') {
      setPasswordConfirmationFailure(true);
      return false;
    }

    if (cpf === '') {
      setCpfFailure(true);
      return false;
    }

    if (cep === '') {
      setCepFailure(true);
      return false;
    }

    if (rg === '') {
      setRgFailure(true);
      return false;
    }

    if (street === '') {
      setStreetFailure(true);
      return false;
    }

    if (street_number === '') {
      setStreetNumberFailure(true);
      return false;
    }

    if (city === '') {
      setCityFailure(true);
      return false;
    }

    if (state === '') {
      setStateFailure(true);
      return false;
    }

    if (ddd === '') {
      setDddFailure(true);
      return false;
    }

    if (number === '') {
      setNumberFailure(true);
      return false;
    }

    if (neighborhood === '') {
      setNeighborhoodFailure(true);
      return false;
    }

    return true;
  }

  const siteKey = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
  const recaptchaRef = useRef(null)

  const onChange = () => {
    if (recaptchaRef.current.getValue()) {
      setCaptcha(true)
    }
  }

  const apperModal = (event) => {
    event?.preventDefault()

    if (captcha && checkParams()) {
      setOpenModal(true);
    } else {
      alert("Todas as informações devem ser preenchidas", 'warn')
    }
  }  

  return (
    <Container>
      <h1>Quero me tornar um cliente Vai de Férias</h1>
      <form onSubmit={(e) => apperModal(e)}>
        <div className="form-1">
          <div className="sub-form-left">
          <h2>Preencha seus dados abaixo</h2>
          </div>
          <div className="sub-form"></div>
        </div>
        <div className="form-1">
          <div className="sub-form-left">
            <Input
              placeholder="Email"
              value={email}
              onChange={(e) => {setEmail(e.target.value); setEmailFailure(false)}}
              failed={emailFailure}
              failMessage="O campo de email não pode estar vazio"
              type="email"
              Icon={MdEmail}
              required
            />
          </div>
          <div className="sub-form">
            <Input
              placeholder="Nome Completo"
              value={name}
              onChange={(e) => {setName(e.target.value); setNameFailure(false)}}
              failed={nameFailure}
              failMessage="O campo Nome Completo não pode estar vazio"
              format='full_name'
              required
            />
          </div>
        </div>
        <div className="form-1">
          <div className="sub-form-left">
            <Input
              placeholder="Senha"
              value={password}
              onChange={(e) => {setPassword(e.target.value); setPasswordFailure(false)}}
              failed={passwordFailure}
              failMessage="O campo Senha não pode estar vazio"
              type="password"
              Icon={MdLock}
              required
            />
          </div>
          <div className="sub-form">
            <Input
              placeholder="Confirmar Senha"
              value={password_confirmation}
              onChange={(e) => {setPassword_confirmation(e.target.value); setPasswordConfirmationFailure(false)}}
              failed={passwordConfirmationFailure}
              failMessage="O campo Confirmar Senha não pode estar vazio"
              type="password"
              Icon={MdLock}
              required
            />
            
          </div>
        </div>
        <div className="form-1">
          <div className="sub-form-left">
            <MaskInput
              mask='(99)'
              placeholder='DDD'
              name='ddd'
              value={ddd} onChange={(e)=> {setDdd(e.target.value); setDddFailure(false)}}
              failed={dddFailure}
              failMessage="O campo DDD não pode estar vazio"
              format='ddd'
              required
            />
            <MaskInput
              mask="99999-9999"
              value={number}
              onChange={(e) => {setNumber(e.target.value); setNumberFailure(false)}}
              failed={numberFailure}
              failMessage="O campo Telefone não pode estar vazio"
              placeholder="Telefone"
              Icon={MdPhone}
              format="phone"
              required
            />
          </div>
          <div className="sub-form">
            <MaskInput
              mask="99999-999"
              onBlur={onBlurCep}
              value={cep}
              onChange={(e) => {setCep(e.target.value); setCepFailure(false)}}
              failed={cepFailure}
              failMessage="O campo CEP não pode estar vazio"
              required
              placeholder="CEP"
              format="cep"
            />
            <Input
              placeholder='Estado'
              name='uf'
              value={state} onChange={(e)=> {setState(e.target.value); setStateFailure(false)}}
              failed={stateFailure}
              failMessage="O campo Estado não pode estar vazio"
              format='state'
            />
          </div>
        </div>
        <div className="form-1">
          <div className="sub-form-left">
            <MaskInput
              mask="999.999.999-99"
              value={cpf}
              onChange={(e) => {setCpf(e.target.value); setCpfFailure(false)}}
              failed={cpfFailure}
              failMessage="O campo CPF não pode estar vazio"
              required
              placeholder="CPF"
            />
          </div>
          <div className='sub-form'>
            <Input
              placeholder='Cidade'
              name='localidade'
              value={city} onChange={(e) => {setCity(e.target.value); setCityFailure(false)}}
              failed={cityFailure}
              failMessage="O campo Cidade não pode estar vazio"
              format='city'
            />
            <Input
              placeholder='Bairro'
              value={neighborhood} onChange={(e) => {setNeighborhood(e.target.value); setNeighborhoodFailure(false)}}
              failed={neighborhoodFailure}
              failMessage="O campo Bairro não pode estar vazio"
              required
              format="neighborhood"
            />
          </div>
        </div>
        <div className='form-1'>
            <div className="sub-form-left">
              <Input
                placeholder="RG"
                value={rg}
                onChange={(e) => {setRG(e.target.value); setRgFailure(false)}}
                failed={rgFailure}
                failMessage="O campo RG não pode estar vazio"
                required
              />
            </div>
            <div className='sub-form'>
                <Input
                    placeholder='Rua'
                    name='logradouro'
                    value={street} onChange={(e) => {setStreet(e.target.value); setStreetFailure(false)}}
                    failed={streetFailure}
                    failMessage="O campo Rua não pode estar vazio"
                    format='street'
                    required
                />
                <Input
                    placeholder='Número'
                    name='numero'
                    value={street_number} onChange={(e) => {setStreet_number(e.target.value); setStreetNumberFailure(false)}}
                    failed={streetNumberFailure}
                    failMessage="O campo Número não pode estar vazio"
                    format='number'
                />
            </div>
        </div>
        <div className="div-recaptcha">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={siteKey}
            onChange={onChange}
          />
        </div>
        <div className="div_button">
          <div className="button">
            <Button type="submit" format="submit">Criar Conta</Button>
          </div>
        </div>
      </form>
      {openModal && <Modal closeModal={setOpenModal} handleSubmit={handleSubmit} />}
    </Container>
  );
};

export default SignUp;
